import useBackward from "@/hooks/useBackward";
import { DOWNLOAD_LINKS } from "@/libraries/constant";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/download")({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation("common");
	const handleOnBack = useBackward();
	return (
		<div className="container wrapper bg-gradient-download h-full flex flex-col items-center">
			<AppBar
				position="fixed"
				className="!bg-transparent text-white !shadow-none"
			>
				<Toolbar variant="dense" className="wrapper w-full">
					<IconButton
						edge="start"
						className="!text-2xl !mr-3"
						onClick={() => handleOnBack()}
					>
						<KeyboardBackspaceIcon className="text-white" />
					</IconButton>
					<p className="text-sm font-semibold">
						{t("common:pages.download.title")}
					</p>
				</Toolbar>
			</AppBar>
			<Box className="flex flex-col items-center gap-y-6 mt-12 py-8">
				<p className="text-3xl text-white font-semibold leading-10 text-center">
					{t("common:pages.download.tagline")}
				</p>
				<p className="text-base text-white font-medium text-center">
					{t("common:pages.download.subtagline")}
				</p>
				<img
					src="/images/application.png"
					alt="application-image"
					loading="lazy"
				/>
				<Box>
					<p className="text-base text-white text-center font-medium mb-2">
						{t("common:pages.download.cta")}
					</p>
					<Box className="flex gap-1">
						<a
							href={DOWNLOAD_LINKS.APP_STORE}
							target="_blank"
							rel="noopener noreferrer"
						>
							<button type="button">
								<img src="/images/apple-button.svg" alt="apple" />
							</button>
						</a>
						<a
							href={DOWNLOAD_LINKS.PLAY_STORE}
							target="_blank"
							rel="noopener noreferrer"
						>
							<button type="button">
								<img src="/images/google-play-button.svg" alt="google-play" />
							</button>
						</a>
					</Box>
				</Box>
			</Box>
		</div>
	);
}
